var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightChevronIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.175 11.9104L9.275 8.01045C9.09167 7.82712 9 7.59378 9 7.31045C9 7.02712 9.09167 6.79378 9.275 6.61045C9.45833 6.42712 9.69167 6.33545 9.975 6.33545C10.2583 6.33545 10.4917 6.42712 10.675 6.61045L15.275 11.2104C15.375 11.3104 15.4458 11.4188 15.4875 11.5354C15.5292 11.6521 15.55 11.7771 15.55 11.9104C15.55 12.0438 15.5292 12.1688 15.4875 12.2854C15.4458 12.4021 15.375 12.5104 15.275 12.6104L10.675 17.2104C10.4917 17.3938 10.2583 17.4854 9.975 17.4854C9.69167 17.4854 9.45833 17.3938 9.275 17.2104C9.09167 17.0271 9 16.7938 9 16.5104C9 16.2271 9.09167 15.9938 9.275 15.8104L13.175 11.9104Z",
    fill: "#5F6368"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightChevronIcon);
export default __webpack_public_path__ + "static/media/rightChevronIcon.9b22dfa46d8090c839c42a06ada3e46d.svg";
export { ForwardRef as ReactComponent };